/* ============================================================
 * Cloud Store CBD · PDP scripts (Vague 2)
 * Init guard : window.__csPdpInit
 * Modules ajoutés progressivement par les tâches suivantes.
 * ============================================================ */
(function () {
  if (window.__csPdpInit) return;
  window.__csPdpInit = true;

  /* === Module Gallery === */
  window.csPdpGallery = function () {
    var root = document.querySelector('[data-cs-gallery]');
    if (!root) return;

    var thumbs = root.querySelectorAll('[data-cs-thumb]');
    var dots = root.querySelectorAll('[data-cs-dot]');
    var slides = root.querySelectorAll('[data-cs-slide]');
    var lightbox = root.querySelector('[data-cs-lightbox]');
    var lightboxImg = root.querySelector('[data-cs-lightbox-img]');
    var lightboxClose = root.querySelector('[data-cs-lightbox-close]');
    var zoomEnabled = root.getAttribute('data-zoom') === 'true';

    function setActive(idx) {
      thumbs.forEach(function (t) {
        var isActive = t.getAttribute('data-idx') == idx;
        t.classList.toggle('is-active', isActive);
        t.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      dots.forEach(function (d) {
        d.classList.toggle('is-active', d.getAttribute('data-idx') == idx);
      });
      if (window.matchMedia('(min-width: 900px)').matches) {
        slides.forEach(function (s) {
          s.classList.toggle('is-active', s.getAttribute('data-idx') == idx);
        });
      }
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { setActive(t.getAttribute('data-idx')); });
    });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { setActive(d.getAttribute('data-idx')); });
    });

    /* Keyboard nav on tablist (arrow keys, Home/End) */
    var thumbList = Array.prototype.slice.call(thumbs);
    thumbList.forEach(function (t, i) {
      t.addEventListener('keydown', function (e) {
        var next = -1;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (i + 1) % thumbList.length;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (i - 1 + thumbList.length) % thumbList.length;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = thumbList.length - 1;
        if (next < 0) return;
        e.preventDefault();
        var target = thumbList[next];
        setActive(target.getAttribute('data-idx'));
        target.focus();
      });
    });

    var main = root.querySelector('.cs-gallery__main');
    if (main && window.matchMedia('(max-width: 899px)').matches) {
      main.addEventListener('scroll', function () {
        var idx = Math.round(main.scrollLeft / main.clientWidth);
        dots.forEach(function (d) {
          d.classList.toggle('is-active', d.getAttribute('data-idx') == idx);
        });
      }, { passive: true });
    }

    if (zoomEnabled && lightbox && lightboxImg) {
      root.querySelectorAll('.cs-gallery__img[data-zoomable="true"]').forEach(function (img) {
        img.addEventListener('click', function () {
          lightboxImg.src = img.getAttribute('data-zoom-src') || img.src;
          lightboxImg.alt = img.alt;
          if (typeof lightbox.showModal === 'function') lightbox.showModal();
          else lightbox.setAttribute('open', '');
        });
      });
      if (lightboxClose) {
        lightboxClose.addEventListener('click', function () { lightbox.close(); });
      }
      lightbox.addEventListener('click', function (e) {
        if (e.target === lightbox) lightbox.close();
      });
    }
  };

  /* === Module Buy panel === */
  window.csPdpBuy = function () {
    var root = document.querySelector('[data-cs-buy]');
    if (!root) return;

    var form = root.querySelector('[data-cs-form]');
    var variantInput = root.querySelector('[data-cs-variant-input]');
    var variantSelect = root.querySelector('[data-cs-variant-select]');
    var priceEl = root.querySelector('[data-cs-price]');
    var priceOldEl = root.querySelector('[data-cs-price-old]');
    var pricePgEl = root.querySelector('[data-cs-price-pg]');
    var cashbackEl = root.querySelector('[data-cs-cashback]');
    var cashbackAmountEl = root.querySelector('[data-cs-cashback-amount]');
    var stockLowEl = root.querySelector('[data-cs-stock-low]');
    var addBtn = root.querySelector('[data-cs-add]');
    var addLabel = root.querySelector('[data-cs-add-label]');
    var buyNowBtn = root.querySelector('[data-cs-buy-now]');
    var qtyDec = root.querySelector('[data-cs-qty-dec]');
    var qtyInc = root.querySelector('[data-cs-qty-inc]');
    var qtyInput = root.querySelector('[data-cs-qty-input]');
    var shareBtn = root.querySelector('[data-cs-share]');

    var variantsData = [];
    var dataScript = root.querySelector('[data-cs-variants-data]');
    if (dataScript) { try { variantsData = JSON.parse(dataScript.textContent); } catch (e) { variantsData = []; } }

    function moneyFormat(cents) {
      // Format EUR sans decimal trailing zeros (basé sur Shopify default)
      var euros = (cents / 100).toFixed(2).replace('.', ',');
      return euros + ' €';
    }

    function findVariant(id) {
      for (var i = 0; i < variantsData.length; i++) {
        if (String(variantsData[i].id) === String(id)) return variantsData[i];
      }
      return null;
    }

    function updateVariant(variant) {
      if (!variant) return;
      variantInput.value = variant.id;

      // Prix
      if (priceEl) priceEl.textContent = moneyFormat(variant.price);
      if (priceOldEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceOldEl.textContent = moneyFormat(variant.compare_at_price);
          priceOldEl.style.display = '';
        } else {
          priceOldEl.style.display = 'none';
        }
      }

      // Prix au gramme
      if (pricePgEl) {
        var titleNum = parseFloat(String(variant.title).replace(',', '.'));
        if (!isNaN(titleNum) && titleNum > 0) {
          var perGram = variant.price / titleNum;
          pricePgEl.textContent = moneyFormat(perGram) + '/g';
          pricePgEl.style.display = '';
        } else {
          pricePgEl.style.display = 'none';
        }
      }

      // Cashback recalc
      if (cashbackEl && cashbackAmountEl) {
        var pct = parseFloat(cashbackEl.getAttribute('data-pct')) || 0;
        if (pct > 0) {
          var amount = (variant.price * pct) / 100;
          cashbackAmountEl.textContent = '+ ' + moneyFormat(amount);
        }
      }

      // Stock low
      if (stockLowEl) {
        var qtyB = stockLowEl.querySelector('[data-cs-stock-qty]');
        var threshold = 5; // fallback, idéalement lu depuis settings via attribute
        if (variant.inventory_management === 'shopify' && variant.inventory_quantity > 0 && variant.inventory_quantity <= threshold) {
          if (qtyB) qtyB.textContent = variant.inventory_quantity;
          stockLowEl.style.display = '';
        } else {
          stockLowEl.style.display = 'none';
        }
      }

      // Disponibilité
      if (addBtn) {
        addBtn.disabled = !variant.available;
        if (addLabel) addLabel.textContent = variant.available ? 'Ajouter au panier' : 'Rupture';
      }
      if (buyNowBtn) buyNowBtn.style.display = variant.available ? '' : 'none';

      // URL update (history.replaceState)
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());

      // og:image update si variant a une image
      if (variant.featured_image && variant.featured_image.src) {
        var ogImg = document.querySelector('meta[property="og:image"]');
        if (ogImg) ogImg.setAttribute('content', variant.featured_image.src);
      }
    }

    // Listener sur input variant (déclenché par cs-grams-picker ou variant select)
    // Note : pas de MutationObserver ici — on contrôle les variant changes via grams-picker pills + variant-select directly.

    // Variant select natif (cas non-grams)
    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        var variant = findVariant(variantSelect.value);
        if (variant) {
          variantInput.value = variant.id;
          updateVariant(variant);
        }
      });
    }

    // cs-grams-picker pills sync : on hook leur click pour piloter notre input
    var gramsPicker = root.querySelector('[data-cs-grams-picker]');
    if (gramsPicker) {
      gramsPicker.querySelectorAll('[data-cs-grams-pill]').forEach(function (pill) {
        pill.addEventListener('click', function () {
          var vid = pill.getAttribute('data-variant-id');
          if (vid && variantInput) {
            variantInput.value = vid;
            var variant = findVariant(vid);
            if (variant) updateVariant(variant);
          }
        });
      });
    }

    // Quantity
    if (qtyDec && qtyInput) {
      qtyDec.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var v = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = Math.max(1, v - 1);
      });
    }
    if (qtyInc && qtyInput) {
      qtyInc.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var v = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = Math.min(99, v + 1);
      });
    }

    // Form submit → AJAX add to cart
    if (form && addBtn) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var fd = new FormData(form);
        addBtn.disabled = true;
        var prevLabel = addLabel ? addLabel.textContent : '';
        if (addLabel) addLabel.textContent = '...';
        fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (addLabel) addLabel.textContent = '✓ Ajouté';
            document.dispatchEvent(new CustomEvent('cart:added', { detail: data }));
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            setTimeout(function () {
              if (addLabel) addLabel.textContent = prevLabel;
              addBtn.disabled = false;
            }, 1400);
          })
          .catch(function () {
            if (addLabel) addLabel.textContent = 'Erreur, réessayer';
            setTimeout(function () {
              if (addLabel) addLabel.textContent = prevLabel;
              addBtn.disabled = false;
            }, 1400);
          });
      });
    }

    // Buy now → submit avec checkout=1
    if (buyNowBtn && form) {
      buyNowBtn.addEventListener('click', function () {
        // Native checkout submit
        var checkoutInput = document.createElement('input');
        checkoutInput.type = 'hidden';
        checkoutInput.name = 'checkout';
        checkoutInput.value = '1';
        form.appendChild(checkoutInput);
        form.action = '/cart/add';
        form.submit();
      });
    }

    // Share
    if (shareBtn) {
      shareBtn.addEventListener('click', function () {
        if (navigator.share) {
          navigator.share({ title: document.title, url: window.location.href }).catch(function () {});
        } else {
          navigator.clipboard.writeText(window.location.href).then(function () {
            shareBtn.textContent = '✓ Lien copié';
            setTimeout(function () { window.location.reload(); }, 1500);
          });
        }
      });
    }
  };

  /* === Module Sticky CTA mobile === */
  window.csPdpSticky = function () {
    var sticky = document.querySelector('[data-cs-sticky]');
    var buy = document.querySelector('.cs-pdp__buy');
    if (!sticky || !buy) return;

    if (!window.matchMedia('(max-width: 899px)').matches) return;

    var addBtn = sticky.querySelector('[data-cs-sticky-add]');
    var priceEl = sticky.querySelector('[data-cs-sticky-price]');

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          sticky.classList.toggle('is-visible', !entry.isIntersecting);
          sticky.setAttribute('aria-hidden', entry.isIntersecting ? 'true' : 'false');
        });
      }, { threshold: 0 });
      io.observe(buy);
    }

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var realAdd = document.querySelector('[data-cs-add]');
        if (realAdd) realAdd.click();
      });
    }

    var realPrice = document.querySelector('[data-cs-price]');
    if (realPrice && priceEl) {
      var obs = new MutationObserver(function () {
        priceEl.textContent = realPrice.textContent;
      });
      obs.observe(realPrice, { childList: true, characterData: true, subtree: true });
    }
  };

  /* === Module Cross-sell (fallback recommendations API) === */
  window.csPdpCrossSell = function () {
    var root = document.querySelector('[data-cs-crossell]');
    if (!root) return;
    if (root.getAttribute('data-mode') !== 'fallback') return;

    var pid = root.getAttribute('data-product-id');
    var grid = root.querySelector('[data-cs-crossell-grid]');
    if (!pid || !grid) return;

    fetch('/recommendations/products?section_id=cs-pdp-cross-sell&product_id=' + pid + '&limit=4&intent=complementary')
      .then(function (r) { if (!r.ok) throw new Error('reco failed'); return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var newGrid = tmp.querySelector('[data-cs-crossell-grid]');
        if (newGrid && newGrid.children.length > 0) {
          var hasReal = false;
          newGrid.querySelectorAll('.cs-product-card').forEach(function () { hasReal = true; });
          if (hasReal) {
            grid.innerHTML = newGrid.innerHTML;
          } else {
            root.style.display = 'none';
          }
        } else {
          root.style.display = 'none';
        }
      })
      .catch(function () {
        root.style.display = 'none';
      });
  };

  /* === Module Recently viewed (localStorage) === */
  window.csPdpRecentlyViewed = function () {
    var root = document.querySelector('[data-cs-recently]');
    if (!root) return;

    var STORAGE_KEY = 'csRecentlyViewed';
    var MAX_ITEMS = 12;
    var DISPLAY_COUNT = 4;

    var current = {
      handle: root.getAttribute('data-product-handle'),
      id: root.getAttribute('data-product-id'),
      title: root.getAttribute('data-product-title'),
      image: root.getAttribute('data-product-image'),
      price: root.getAttribute('data-product-price'),
      url: '/products/' + root.getAttribute('data-product-handle')
    };

    var stored = [];
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (raw) stored = JSON.parse(raw);
      if (!Array.isArray(stored)) stored = [];
    } catch (e) { return; }

    stored = stored.filter(function (item) { return item && item.handle !== current.handle; });
    stored.unshift(current);
    if (stored.length > MAX_ITEMS) stored = stored.slice(0, MAX_ITEMS);

    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(stored)); } catch (e) {}

    var toRender = stored.filter(function (item) { return item.handle !== current.handle; }).slice(0, DISPLAY_COUNT);
    if (toRender.length === 0) return;

    var grid = root.querySelector('[data-cs-recently-grid]');
    var tpl = root.querySelector('[data-cs-recently-tpl]');
    if (!grid || !tpl) return;

    toRender.forEach(function (item) {
      var clone = tpl.content.cloneNode(true);
      var a = clone.querySelector('.cs-recently-card');
      var img = clone.querySelector('img');
      var title = clone.querySelector('.cs-recently-card__title');
      var price = clone.querySelector('.cs-recently-card__price');
      a.href = item.url;
      img.src = item.image;
      img.alt = item.title;
      title.textContent = item.title;
      price.textContent = item.price;
      grid.appendChild(clone);
    });

    root.removeAttribute('hidden');
  };

  function init() {
    /* Modules câblés progressivement */
    if (window.csPdpGallery) window.csPdpGallery();
    if (window.csPdpBuy) window.csPdpBuy();
    if (window.csPdpSticky) window.csPdpSticky();
    if (window.csPdpCrossSell) window.csPdpCrossSell();
    if (window.csPdpRecentlyViewed) window.csPdpRecentlyViewed();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
